export const LIST_NUMBER_ANALYZE = 'LIST_NUMBER_ANALYZE';
export const FETCH_NUMBER_ANALYZE = 'FETCH_NUMBER_ANALYZE';
export const CLEAR_NUMBER_ANALYZE = 'CLEAR_NUMBER_ANALYZE';


